"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VideoLocalizedReferenceSchema = void 0;
exports.VideoLocalizedReferenceSchema = {
    "$id": "https://www.redbull.com/schemas/reference/localized/content/videos.schema.json",
    "$schema": "https://json-schema.org/draft/2020-12/schema",
    "title": "VideoLocalizedReference",
    "description": "A video clip",
    "type": "object",
    "required": [
        "type",
        "id"
    ],
    "properties": {
        "type": {
            "enum": [
                "rrn:content:videos"
            ],
            "type": "string"
        },
        "id": {
            "type": "string",
            "pattern": "^rrn:content:[0-9a-z\\-_]+:[0-9a-f]{8}[-]?([0-9a-f]{4}[-]?){3}[0-9a-f]{12}:[a-z]{2}-[A-Z]{2,3}$"
        }
    }
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidmlkZW9zLnNjaGVtYS5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uLy4uLy4uL3NyYy9tb2R1bGVzL3JlZmVyZW5jZS9sb2NhbGl6ZWQvY29udGVudC92aWRlb3Muc2NoZW1hLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7OztBQUFhLFFBQUEsNkJBQTZCLEdBQUc7SUFDM0MsS0FBSyxFQUFFLGdGQUFnRjtJQUN2RixTQUFTLEVBQUUsOENBQThDO0lBQ3pELE9BQU8sRUFBRSx5QkFBeUI7SUFDbEMsYUFBYSxFQUFFLGNBQWM7SUFDN0IsTUFBTSxFQUFFLFFBQVE7SUFDaEIsVUFBVSxFQUFFO1FBQ1YsTUFBTTtRQUNOLElBQUk7S0FDTDtJQUNELFlBQVksRUFBRTtRQUNaLE1BQU0sRUFBRTtZQUNOLE1BQU0sRUFBRTtnQkFDTixvQkFBb0I7YUFDckI7WUFDRCxNQUFNLEVBQUUsUUFBUTtTQUNqQjtRQUNELElBQUksRUFBRTtZQUNKLE1BQU0sRUFBRSxRQUFRO1lBQ2hCLFNBQVMsRUFBRSxpR0FBaUc7U0FDN0c7S0FDRjtDQUNGLENBQUEifQ==